import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=115096c1&scoped=true"
import script from "./Faq.js?vue&type=script&lang=js&external"
export * from "./Faq.js?vue&type=script&lang=js&external"
import style0 from "./Faq.scss?vue&type=style&index=0&id=115096c1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115096c1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotAccordionItem: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/AccordionItem/AccordionItem.vue').default,HotAccordion: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Accordion/Accordion.vue').default,HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
